module.exports = __webpack_public_path__ + "img/3.032c237e.png";